import { useTrackAppInsightsEvent } from '@/app-insights/application-insights-provider';
import { ApplicationInsightsEvent } from '@/app-insights/application-insights-events';

export const useAnalyticsTrackEvent = () => {
  const track = useTrackAppInsightsEvent();
  return (event: ApplicationInsightsEvent, properties?: Record<string, string>) => track(event, properties);
};

export const trackAnalyticsEvent = (event: ApplicationInsightsEvent, properties?: Record<string, string>) => {
  const tracker = useTrackAppInsightsEvent();
  tracker(event, properties);
}; 